import React from "react";
import About from "../AboutMe";

const Resume = () => {
  return (
    <div className="page resume-page">
      <About />
    </div>
  );
};

export default Resume;
